import { FC } from "react";
import classNames from "classnames";

import { PageHeaderProps } from "./PageHeader.type";

const PageHeader: FC<PageHeaderProps> = ({ backgroundImage, title, intro, contentClassName = "", containerClassName = "" }) => {
	const titleIsReactComponent = typeof title !== "string";

	return (
		<div className={classNames("w-full relative overflow-hidden")}>
			{backgroundImage ? (
				<>
					<div
						className="w-full h-full absolute left-0 top-0 bg-cover bg-center z-0"
						style={{ backgroundImage: `url(${backgroundImage})` }}
					/>
					<div
						className="w-full h-full absolute left-0 top-0 z-[1]"
						style={{
							opacity: 0.9,
							background: "linear-gradient(to right, #0047ba, rgba(0, 71, 186, 0.5))",
						}}
					/>
				</>
			) : null}
			<div
				className={classNames(
					"w-full h-full relative z-[3] flex flex-col items-start justify-start md:justify-center min-h-[18rem] lg:min-h-[22rem]",
					"px-6 py-8 md:px-9 md:py-9 xl:p-14",
					containerClassName,
				)}
			>
				<div className={classNames("max-w-6xl mx-auto w-full flex flex-col items-start justify-start gap-5", contentClassName)}>
					{titleIsReactComponent ? (
						title
					) : (
						<h1 className={classNames({ "text-white md:max-w-2xl leading-tight": !!backgroundImage })}>{title}</h1>
					)}

					{intro ? <p className={classNames("text-lg w-full lg:w-2/3", { "text-white": !!backgroundImage })}>{intro}</p> : null}
				</div>
			</div>
		</div>
	);
};

export { PageHeader };
